import React, { Component } from 'react';
import PropTypes from 'prop-types';
import  SimpleCard  from './SimpleCard';
import { Segment } from 'semantic-ui-react';
import config from '../config';
  
class ColumnsPage extends Component {
  render() {
    return (
      <Segment.Group horizontal>
      {this.props.columns.map(item => {
        return(<div style={Style.card}>
          <SimpleCard 
            title={item.title}
            text={item.text}
            subtitle={item.subtitle}
            image={item.image}
          />
          </div>)})}
      </Segment.Group>
    );
  }
}

const Style = {
  card: {
    height:'auto',
    //top:'-15px',
    width: '50%',
    background: config.website.header.background,//"#40bf40"
  },
}
ColumnsPage.PropTypes = {
  columns: PropTypes.array,
};

export default ColumnsPage;



// WEBPACK FOOTER //
// ./src/components/ColumnsPage.js